import {Component, OnInit} from '@angular/core';
import {UserService} from '../services/user.service';

@Component({
  selector: 'app-my-account-view',
  templateUrl: './my-account-view.component.html',
  styleUrls: ['./my-account-view.component.css']
})
export class MyAccountViewComponent implements OnInit {
  currentUser: any;
  newCurrentUser: any;
  showChangePasswordForm = false;
  showEditMyAccoundForm = false;
  newPassword = '';
  confirmPassword = '';
  currentPassword = '';

  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.newCurrentUser = Object.assign({}, this.currentUser);
  }

  hiddenForms() {
    return !this.showChangePasswordForm && !this.showEditMyAccoundForm;
  }

  viewEditMyAccount() {
    this.showEditMyAccoundForm = true;
  }

  viewChangePasswordForm() {
    this.showChangePasswordForm = true;
  }

  cancelEditMyAccount() {
    this.newCurrentUser = Object.assign({}, this.currentUser);
    this.showEditMyAccoundForm = false;
  }

  cancelChangeMyPassword() {
    this.showChangePasswordForm = false;
  }

  editMyAccount() {
    this.userService.update(this.newCurrentUser).subscribe(() => {
      this.currentUser = Object.assign({}, this.newCurrentUser);
      localStorage.setItem('currentUser', JSON.stringify(this.newCurrentUser));
      this.showEditMyAccoundForm = false;
    });
  }

  changeMyPassword() {
    this.userService.changePassword(this.currentPassword, this.newPassword).subscribe(
      res => this.showChangePasswordForm = false);
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/my-account-view/my-account-view.component.ts